import { Device } from "@fairfleet/geotab";

export type WithDevice<T extends Device = Device> = {
  device: T;
};

export function groupByDeviceId<T extends WithDevice>(items: T[]): Record<string, T[]> {
  return items.reduce<Record<string, T[]>>((acc, item) => {
    const id = item.device.id;
    if (!acc[id]) {
      acc[id] = [];
    }
    acc[id].push(item);
    return acc;
  }, {});
}
